// extracted by mini-css-extract-plugin
export default {"buttonLink":"AntDButtonLink_buttonLink__kYpiH"};